import { css, SerializedStyles } from '@emotion/react'
import { BrowserStyles } from 'components/styles/primitives/modifiers/browserHacks/disableAppearance'

/**
 * Applies the passed styles to the 'thumb' of a range input. Handles removal of browser defaults.
 * @param {CSSInterpolation} styles
 * @returns {StyleSelector}
 */
export const ifRangeThumb = (styles: SerializedStyles): SerializedStyles => css`
	// These cannot be combined into a single rule because some people just want to watch the world burn
	::-ms-thumb {
		${BrowserStyles.disableAll}
		${styles}
	}
	::-moz-range-thumb {
		${BrowserStyles.disableAll}
		${styles}
	}
	::-webkit-slider-thumb {
		${BrowserStyles.disableAll}
		${styles}
	}
`
